import { takeEvery, fork, put, all, call } from 'redux-saga/effects';

import { customHeaders, adminAPIURL } from '../../../../../Containers/Config/index.js';
import { DOWNLOAD_PRICE_FILE, DOWNLOAD_PRICE_FILE_SUCCESS, DOWNLOAD_PRICE_FILE_ERROR } from '../../actions.js';
import apiCall from '../../../apiCall.js';

function* downloadPriceType({ payload }) {
  try {
    const filteredHeaders = { ...customHeaders };
    delete filteredHeaders['X-Requested-By'];

    const response = yield call(apiCall, {
      url: `${adminAPIURL}/v2/benefit-type/airport-transfer/${payload?.priceType}`,
      method: 'POST',
      data: payload?.data,
      isOctetStream: true,
      headers: {
        'Content-Type': 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
        // Authorization: Constant?.CLIENT_TOKEN,
        ...filteredHeaders,
        // withCredentials: true
      },
    });

    if (response.status === 200) {
      yield put({
        type: DOWNLOAD_PRICE_FILE_SUCCESS,
        payload: response?.data,
      });
    } else {
      yield put({
        type: DOWNLOAD_PRICE_FILE_ERROR,
        payload: response.data.message,
      });
    }
  } catch (error) {
    yield put({ type: DOWNLOAD_PRICE_FILE_ERROR, payload: error });
  }
}

export function* watchdownloadPriceType() {
  yield takeEvery(DOWNLOAD_PRICE_FILE, downloadPriceType);
}

function* downloadPriceTypeSaga() {
  yield all([fork(watchdownloadPriceType)]);
}

export default downloadPriceTypeSaga;
